<template>
    <div>
        <div class="page-title-container lighter-shadow">
            <i class="fas fa-building icon"></i>
            <h1>Списък на фирми</h1>
        </div>
        <Grid class="grid"
              :config="config"
              :gridData="gridData"
              :loading="isLoading"
              @row-clicked="rowClicked">
        </Grid>

        <!--    Add profession form    -->
        <CompanyEdit class="company-edit-form" v-if="isUserAdmin" @saved-company="refreshCompanies"/>

        <CompanyEdit class="popup-shadow" v-if="shouldEdit && isUserAdmin" @saved-company="savedCompany" @close-clicked="closeClicked" :company="selectedCompany"/>
    </div>
</template>

<script>
    import Grid from "@/shared/components/grid/Grid";
    import {mapGetters} from "vuex";
    import companyListGridConfig from "@/components/worker/company-list-grid.config";
    import sharedService from "@/services/shared.service";
    import CompanyEdit from "@/components/worker/CompanyEdit";
    import {cloneDeep} from "lodash";

    export default {
        name: "CompanyList",
        components: {CompanyEdit, Grid},
        created() {
            this.refreshCompanies();

            if (!this.isUserAdmin) {
              const tempConfig = cloneDeep(companyListGridConfig);
              tempConfig.props.selectableColumn.show = false;
              this.config = tempConfig;
            }
       },
        data() {
            return {
                config: companyListGridConfig,
                gridData: [],
                isLoading: true,
                newProfession: {
                    name: null
                },
                errors: {},
                shouldEdit: false,
                selectedCompany: null
            }
        },
        methods: {
            refreshCompanies() {
                sharedService.fetchCompanies()
                    .then(({data}) => {
                        if (data) {
                            data.map((company) => {
                                const tempCompany = company;
                                tempCompany.countryName = company.country ? company.country.name : '';
                                return tempCompany;
                            });
                            this.gridData = data;
                            this.isLoading = false;
                        }
                    });
            },
            rowClicked(row) {
                this.shouldEdit = true;
                this.$store.commit('setHasModal', true);
                this.selectedCompany = {id: row.id, name: row.name, address: row.address, company: row.company}
            },
            savedCompany() {
                this.refreshCompanies();
                this.selectedCompany = null;
                this.shouldEdit = false;
                this.$store.commit('setHasModal', false);
            },
            closeClicked() {
                this.selectedCompany = null;
                this.shouldEdit = false;
                this.$store.commit('setHasModal', false);
            }
        },
        computed: {
            ...mapGetters(['user', 'isUserAdmin']),
        },
        watch: {
          user: {
            handler() {
              if (!this.isUserAdmin) {
                const tempConfig = cloneDeep(companyListGridConfig);
                tempConfig.props.selectableColumn.show = false;
                this.config = tempConfig;
              }
            },
            deep: true
          }
        }
    }
</script>

<style scoped>
    @import '../../css/shared/tabs.css';

    .company-edit-form {
        float: left;
        margin-top: 10px;
        margin-left: 100px;
    }

    .grid {
        margin-top: 30px;
        display: inline-block;
        float: left;
    }
</style>
